import { forwardRef, PropsWithChildren } from 'react'
import { styled } from '@portfolio/styles'
import { SpacingType } from '@portfolio/models'

const Wrap = styled('section', {
  variants: {
    type: {
      DEFAULT: {
        marginTop: '$mobileSectionMarginL',
        marginBottom: '$mobileSectionMarginL',
        '@lg': {
          marginTop: '$desktopSectionMarginL',
          marginBottom: '$desktopSectionMarginL',
        },
      },
      MEDIUM: {
        marginTop: '$mobileSectionMarginM',
        marginBottom: '$mobileSectionMarginM',
        paddingBlock: '24px',
        '@lg': {
          marginTop: '$desktopSectionMarginM',
          marginBottom: '$desktopSectionMarginM',
        },
      },
      CARD: {
        marginTop: '$mobileSectionMarginL',
        marginBottom: '$mobileSectionMarginL',
        '@lg': {
          marginTop: '$sectionMarginS',
          marginBottom: '$sectionMarginS',
          '&:last-of-type': {
            marginBottom: 0,
            borderBottom: 0,
          },
        },
      },
      MEDIA: {
        marginTop: '$sectionMarginM',
        marginBottom: '$sectionMarginM',
      },
      FIRST_SECTION: {
        marginTop: 'calc($headerHeight + $mobileSectionMarginL)',
        '@lg': {
          marginTop: 'calc($headerHeight + $desktopSectionMarginL)',
        },
      },
      NO_MARGIN: {},
      RICH_TEXT_SM: {
        marginTop: '$40',
        marginBottom: '$40',
        '&:first-child': {
          marginTop: 0,
        },
      },
      RICH_TEXT_MD: {
        marginTop: '$40',
        marginBottom: '$40',
        '@lg': {
          marginTop: '$72',
          marginBottom: '$72',
        },

        '&:first-child': {
          marginTop: 0,
        },
      },
      RICH_TEXT_LG: {
        marginTop: '$48',
        marginBottom: '$48',
        '@lg': {
          marginTop: '$96',
          marginBottom: '$96',
        },

        '&:first-child': {
          marginTop: 0,
        },
      },
      NONE: {},
    },
    topBorder: {
      true: {
        borderTop: '1px solid $gray500',
      },
      false: {},
    },
  },
})

export const SectionWrapper = forwardRef<
  HTMLDivElement,
  PropsWithChildren<{
    type?: SpacingType
    id?: string
    className?: string
    topBorder?: boolean | null
  }>
>(({ children, className, type = 'DEFAULT', id, topBorder }, ref) => {
  return (
    <Wrap
      className={className}
      id={id}
      ref={ref}
      type={type}
      topBorder={topBorder || false}
    >
      {children}
    </Wrap>
  )
})
